import React, { useState } from "react";
import { FormControl, FormLabel, Box, Button, Stack } from "@mui/joy";
import MDEditor from '@uiw/react-md-editor';
import { AutoAwesome } from '@mui/icons-material';
import AISummaryModal from './AISummaryModal';

interface SummarySectionProps {
  value: string;
  onChange: (value: string) => void;
  userUuid: string;
}

const SummarySection: React.FC<SummarySectionProps> = ({ value, onChange, userUuid }) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <FormControl>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <FormLabel
          sx={{
            fontWeight: 500,
            fontSize: '1rem',
            color: '#1A1B1D',
            mb: 0,
          }}
        >
          Summary
        </FormLabel>
        <Button
          size="sm"
          variant="soft"
          color="primary"
          startDecorator={<AutoAwesome />}
          onClick={() => setModalOpen(true)}
          // sx={{
          //   fontSize: '0.875rem',
          //   fontWeight: 500,
          // }}
        >
          Generate
        </Button>
      </Stack>
      <Box
        data-color-mode="light"
        sx={{
          '& .w-md-editor': {
            borderRadius: '8px',
            border: '1px solid #CDD7E1',
          },
          '& .w-md-editor-toolbar': {
            borderBottom: '1px solid #CDD7E1',
            backgroundColor: '#F8F9FA',
          },
          '& .w-md-editor-text': {
            minHeight: '150px',
          },
          '& .wmde-markdown': {
            '& ul': {
              listStyleType: 'disc',
              listStylePosition: 'outside',
              paddingLeft: '1.5em',
            },
            '& ol': {
              listStyleType: 'decimal',
              listStylePosition: 'outside',
              paddingLeft: '1.5em',
            },
            '& li': {
              display: 'list-item',
            },
          },
        }}
      >
        <MDEditor
          value={value}
          onChange={(val) => onChange(val || '')}
          preview="live"
          height={200}
          visibleDragbar={false}
        />
      </Box>

      <AISummaryModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onUseSummary={(summary) => onChange(summary)}
        userUuid={userUuid}
      />
    </FormControl>
  );
};

export default SummarySection;

